import { SplendidCRMDFService } from './../services/SplendidCRMDFService';
import { Component }        from '@angular/core';
import { Router }             from '@angular/router';
import * as constants from '../config/constants';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { NgxSpinnerService } from 'ngx-spinner';


import { UserProfile } from 'app/models/Profile';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { User } from 'app/models/Users';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./style.css'],
})


export class LoginComponent {
    message:string = '';
    _VERSION:string = constants.VERSION;

    public options = {
      position: ["bottom", "left"],
      timeOut: 5000,
      lastOnBottom: true
    }

    public loginForm: FormGroup;
    private currentUser : User;
    constructor (
        private _http : HttpClient, 
        private formBuilder: FormBuilder, 
        private _router: Router, 
        private _notificationsService: NotificationsService,
        private splendidService: SplendidCRMDFService,
        private loadinService: NgxSpinnerService) {
        this.loginForm = formBuilder.group({
            email: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    private storeToken(data) {
        //this.currentUser = data;
        //console.log(JSON.stringify(data));
        localStorage.setItem('session_token', data);
        this._router.navigate(['/calendario']);
    }

    //TODO reenviar al dashboard
    formSubmit() {
        var headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        
        this.loadinService.show();
        try {        
        this._http.post(constants.DREAMFACTORY_INSTANCE_URL + '/user/session', JSON.stringify(this.loginForm.value), { headers })
            .subscribe((data:any) => {
                let result = data;
                this.splendidService.setIsLogued(true);

                let userProfile: User = data;
                   
                this.splendidService.setUserProfile(userProfile);
                this.storeToken(result.session_token); 
                // recupera el perfil del usuario que ingresó
                this.splendidService.getProfile().subscribe((response:any)=> {
                    // let result = JSON.parse(response._body);
                    // let userP = User.fromJson(result);      
                                                                                                                                                                                                
                    this.splendidService.setUserProfile(response);

                    //TODO: recuperar clientes
                    // this.splendidService.queryAccounts().subscribe((accounts) => {
                    //     this.splendidService.setAccouts(accounts);
                    // });
                    this.loadinService.hide();
                });
                this._router.navigate(['/calendario']);
            }, (error) => {
                this.splendidService.setIsLogued(false);
                let result = error.error;
                this.loadinService.hide();
                //this.notificationService.show('error', error.error.message);
                this._notificationsService.error(
                    'Error de autenticación',
                    result.Message,
                    {
                        timeOut: 5000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: false
                    }
                )
            });
        } catch(error) {
            console.log(error);
        }
    }

    public logout() {
        //console.log();
        localStorage.setItem('session_token', '');
        localStorage.setItem('role', '');
        //window.location.hash='login';
        this._router.navigate(['login']);
        this.splendidService.setIsLogued(false);
    }

    // public getCurrentUser(): User {
    //     return this.currentUser;
    // }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/login/login.component.ts